export default __webpack_public_path__ + "static/media/grafema_minha-casa_08.38ad3af5.jpg";